<template>
  <div>
    <!-- 添加地址列表 -->
    <el-dialog
        :close-on-press-escape="false" :close-on-click-modal="false"
        :modal-append-to-body="false"
        top="25vh"
        :visible.sync="addressAddDialog"
        width="900px"
        title="添加地址"
        :before-close="addressAddCloseDialog"
    >
      <div class="add-box-address">
        <el-form
            ref="addressForm"
            :model="addressForm"
            label-width="120px"
            :rules="addressRules"
        >
          <el-form-item label="选择区域" prop="district">
            <el-cascader
                v-model="addressForm.district"
                :options="areaOptions"
                :props="{ expandTrigger: 'hover' }"
                :style="{ width: '100%' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input
                v-model="addressForm.address"
                type="textarea"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="name">
            <el-input
                v-model="addressForm.name"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input
                v-model="addressForm.phone"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="is_default">
            <el-checkbox v-model="addressForm.is_default"
            >设置为默认地址
            </el-checkbox
            >
          </el-form-item>
        </el-form>
        <div slot="footer" class="flex-end">
          <el-button @click="addressAddCloseDialog">取 消</el-button>
          <el-button type="primary" @click="addressAddSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getAreaOptions} from "@/api/modules/common";
import {addressAdd, addressUpdate, getAddressDetail} from "@/api/modules/user";

export default {
  name: "addAddresss",
  props: {
    addressAddDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      // 地址表单
      addressForm: {
        district: [],
        address: "",
        is_default: true,
        name: "",
        phone: "",
      },
      // 地址表单校验
      addressRules: {
        district: [
          {required: true, message: "请选择区域", trigger: "change"},
        ],
        address: [
          {required: true, message: "请输入详细地址", trigger: "blur"},
        ],
        name: [{required: true, message: "请输入联系人", trigger: "blur"},
          {min: 1, max: 10, message: "联系人长度不能大于10个字符", trigger: "blur"},
          {
            pattern: /^(?=.*[^\d])[\s\S]*$/,
            message: "联系人不能为纯数字",
            trigger: "blur"
          }],
        phone: [
          {required: true, message: "请输入联系电话", trigger: "blur"},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
      },
      areaOptions: [],
    };
  },
  mounted() {
    this.getAreaOptions();
  },
  watch: {
    id: {
      handler(newVal) {
        // 如果有id，则为编辑模式，获取详情
        if (newVal) {
          this.editAddress();
        } else {
          this.addressForm = {
            id: "",
            district: [],
            address: "",
            is_default: true,
            name: "",
            phone: "",
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    editAddress() {
      getAddressDetail(this.id).then((res) => {
        this.addressForm = res.data.data;
        this.addressForm.district = [
          this.addressForm.provinceId,
          this.addressForm.cityId,
          this.addressForm.areaId,
        ];
        this.addressForm.is_default =
            this.addressForm.is_default == 1 ? true : false;

      });
    },
    // 获取省市区
    getAreaOptions() {
      getAreaOptions().then((res) => {
        this.areaOptions = res.data.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
            children: item.children.map((item) => {
              return {
                value: item.id,
                label: item.name,
                children: item.children.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                }),
              };
            }),
          };
        });
      });
    },
    // 关闭弹窗
    addressAddCloseDialog() {
      this.$emit("close", false);
      this.$refs["addressForm"].resetFields();
    },

    // 校验地址
    addressAddSubmit() {
      this.$refs["addressForm"].validate((valid) => {
        if (valid) {
          this.addressForm.is_default = this.addressForm.is_default ? 1 : 2;
          this.sumbitAddress();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 提交地址
    async sumbitAddress() {
      let res;
      if (this.addressForm.id) {
        res = await addressUpdate(this.addressForm.id, this.addressForm);
      } else {
        delete this.addressForm.id;
        res = await addressAdd(this.addressForm);
      }
      if (res.data.code == 10000) {
        this.$message.success({
          message: res.data.message,
          duration: 2000,
          offset: 200,
        });
        this.$refs["addressForm"].resetFields();
        this.addressAddCloseDialog();
        this.$emit("success");
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
